import React__default, { useContext, createContext } from 'react';
import { $ as $49c51c25361d4cd2$export$ee0f7cc6afcd1c18 } from './3rdPartyModules/_react-aria/overlays/dist/import-50676d5c-369dec22.js';

const PreventScrollContext = /*#__PURE__*/createContext(false);
const PreventScroll = ({
  isScrollEnabled,
  children
}) => {
  const isPreventScroll = useContext(PreventScrollContext);
  $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: isScrollEnabled ? true : isPreventScroll
  });
  if (isPreventScroll) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  return /*#__PURE__*/React__default.createElement(PreventScrollContext.Provider, {
    value: true
  }, children);
};
PreventScroll.defaultProps = {
  isScrollEnabled: false
};
var PreventScroll$1 = PreventScroll;

export { PreventScroll$1 as P };
//# sourceMappingURL=PreventScroll-b8b12465-35f323e4.js.map
